import { Grid } from '@material-ui/core';
import { FindInPage } from '@material-ui/icons';
import { Button } from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';
import Partenaire from 'components/Icons/Partenaire';
import Team from 'components/Icons/Team';
import { FormattedDate, FormattedMessage } from 'react-intl';

import theme from '../theme';

const {
  colors: { background },
} = theme;

const Presentation = ({
  foundationDate,
  email,
  headOffice,
  location,
  name,
  phone,
  publicPrive,
  refetch,
  sector,
  sizeMax,
  sizeMin,
  specialization,
  type,
  website,
}) => {
  const {
    classes,
    css,
    cx,
    theme: { fontSizes, spacing },
  } = useStyles(styles);

  return (
    <div style={{ padding: spacing(2.5) }} align="center">
      {/* <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
    <Button
      startIcon={<FindInPage />}
      color="primary"
      //   onClick={handleOpenCreateAnnonce}
      variant="contained"
      className={classes.btn}
      style={{ width: '90%' }}
    >
      <FormattedMessage id="business.annoncesCandidats.btnPublierAnnonce" />
    </Button>
  </Grid>
  <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
    <Button
      startIcon={<Partenaire />}
      color="primary"
      //   onClick={handleOpenCreateAnnonce}
      variant="contained"
      className={classes.btn}
      style={{ width: '90%' }}
    >
      <FormattedMessage id="business.annoncesCandidats.btnPublierAnnonce" />
    </Button>
  </Grid>
  <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
    <Button
      startIcon={<Team />}
      color="primary"
      //   onClick={handleOpenCreateAnnonce}
      variant="contained"
      className={classes.btn}
      style={{ width: '90%' }}
    >
      <FormattedMessage id="business.annoncesCandidats.btnPublierAnnonce" />
    </Button>
  </Grid>
  <Grid className={classes.infoContainer} container></Grid>
  {/* <Grid className={classes.infoContainer} container>
            <Grid className={classes.infoTitle} item xs={12} sm={4} md={3} >
                <FormattedMessage id="vitrine.specialization" />
            </Grid>
            <Grid item xs={12} md={8}>
                <div className={classes.infoDetails}>{specialization || 'À remplir'}</div>
            </Grid>
        </Grid> */}
    </div>
  );
};

const styles = ({ fontSizes, spacing }) => ({
  container: {
    background,
    borderRadius: 10,
    padding: spacing(2.5),
    marginTop: spacing(3),
  },
  gridItem: {
    color: '#0183FF',
    textDecoration: 'none',
    '@media (max-width:1020px)': { marginLeft: 0 },
  },
  title: {
    '@media only screen and (max-width:1920px)': {fontSize: '15.00px'}, '@media only screen and (max-width:1600px)': {fontSize: '14.00px'},
    fontWeight: 600,
    color: '#152652',
    marginBottom: spacing(3),

    
    

  },
  infoContainer: {
    paddingBottom: spacing(1),
  },
  infoTitle: {
    color: '#152652',
    marginBottom: spacing(0.5),
    '& > *': {
      marginBottom: spacing(1),
    },
  },
  infoDetails: {
    color: '#5D75A8',
    marginLeft: '10px',
    '@media (max-width:1020px)': { marginLeft: 0 },
  },
  modifyLink: {
    a: {
      textDecoration: 'none',
      color: '#0183FF',
    },
  },
  btn: {
    marginTop: spacing(1),
    boxShadow: 'none',
    width: '100%',
    '@media only screen and (max-width:1920px)': {fontSize: '15.00px'}, '@media only screen and (max-width:1600px)': {fontSize: '14.00px'},
    '@media (max-width:1475px)': { width: '100%' },
    '@media (max-width:1383px)': { width: '100%' },
    '@media (max-width:1305px)': { width: '100%' },
    '@media (max-width:1239px)': { width: '80%' },
    '@media (max-width:1180px)': { width: '85%' },
    '@media (max-width:1130px)': { width: '90%' },
    '@media (max-width:1082px)': { width: '100%' },
    '@media (max-width:640px)': { width: '100%' },
  },
});

export default Presentation;
